import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import MyTypography from "@saleor/components/MyTypography";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { useIntl } from "react-intl";

interface RouterProps {
  listResult: any[];
  open: boolean;
  onClose: () => void;
  onChoose: (value) => void;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        minWidth: 400,
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
        borderRadius: 16,
        padding: 24,
        overflow: "auto"
      }
    },
    dialogTitle: {
      padding: 0,
      "& .MuiTypography-root": {
        display: "flex",
        alignItems: "center"
      }
    },
    mainTitle: {
      color: theme.palette.info.main
    },
    closeIcon: {
      marginLeft: "auto",
      cursor: "pointer"
    },
    dialogCenter: {
      padding: "0px !important",
      marginTop: "10px !important"
    },
    numberResult: {
      fontWeight: 700
    },
    boxTable: {
      border: `solid 1px ${theme.palette.grey[300]}`,
      marginTop: 16
    },
    rowClickable: {
      cursor: "pointer"
    }
  }),
  { name: "ModalResultRoute" }
);

const ModalResultRouter: React.FC<RouterProps> = props => {
  const { listResult, open, onClose, onChoose } = props;
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog className={classes.root} open={open} onClose={onClose}>
      <DialogTitle className={classes.dialogTitle}>
        <MyTypography variant={"h6"} className={classes.mainTitle}>
          {intl.formatMessage({ defaultMessage: "Route" })}
        </MyTypography>
        <CloseOutlined
          id="closeButton"
          data-testid="closeButton"
          className={classes.closeIcon}
          onClick={onClose}
        />
      </DialogTitle>
      <DialogContent className={classes.dialogCenter}>
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "Search Results" })} (
          <span className={classes.numberResult}>{listResult.length}</span>)
        </MyTypography>
        <div className={classes.boxTable}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCellHeader>
                  <MyTypography variant={"captionBold"}>
                    {intl.formatMessage({ defaultMessage: "Route Code" })}
                  </MyTypography>
                </TableCellHeader>
                <TableCellHeader>
                  <MyTypography variant={"captionBold"}>
                    {intl.formatMessage({ defaultMessage: "Route Name" })}
                  </MyTypography>
                </TableCellHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {listResult.length ? (
                listResult.map(item => (
                  <TableRow
                    id={`chooseRouteAction[${item.routeCode}]`}
                    data-testid={`chooseRouteAction[${item.routeCode}]`}
                    key={item.routeCode}
                    className={classes.rowClickable}
                    onClick={() => onChoose(item)}
                  >
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item.route}
                      </MyTypography>
                    </TableCell>
                    <TableCell>
                      <MyTypography variant={"body3"}>
                        {item.routeDescription}
                      </MyTypography>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2}>
                    <MyTypography variant={"body3"}>
                      ไม่พบข้อมูลที่ค้นหา
                    </MyTypography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ModalResultRouter;
